import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IconWarning from '../../assets/icon-warning.svg';

function FormErrorsModal({ showModal, message = '', errorMessageList, handleCloseModal =() => {} }) {
  const { t } = useTranslation();

  const handleClose = () => {
    handleCloseModal();
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      contentClassName="border-0"
      centered
    >
      <Modal.Header className="pt-3 pb-0 border-0">
        <Modal.Title className="mx-auto text-center">
          <img src={IconWarning} alt="icon-warning" className="pb-3" />
          {/* <p className="mb-0 app-txt-red">{t('TXT_TITLE_WARNING')}</p> */}
          <p className="mb-0 app-fw-notosans-bold">{t('TXT_TITLE_NOTICE')}</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message !== '' && (
          <p className="mb- app-txt-granite-80-dark text-center app-fs-15 app-lh-h4">
            {message}
          </p>
        )}

        <ul className="app-fw-notosans-regular">
          {errorMessageList.map((errorMessage, index) => (
            <li
              key={index}
              className="mb-0 app-txt-granite-80-dark app-fs-15 app-lh-h4"
            >
              {errorMessage}
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer className="border-0 mx-auto">
        <Button
          variant=""
          onClick={handleClose}
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height px-4"
        >
          {t('TXT_BTN_ACCEPT')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FormErrorsModal;
